import { render, staticRenderFns } from "./HeaderSteps.vue?vue&type=template&id=045aae66&"
import script from "./HeaderSteps.vue?vue&type=script&lang=js&"
export * from "./HeaderSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports